import Box from '@mui/material/Box';
import NRHighlightedText from '../NRHighlightedText/NRHighlightedText';
import { useTheme } from '@mui/material/styles';
import { getWeightedColor, getWeightedColorAlt, isNumber } from '../../utils/utils';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

function formatDelta(delta) {
  const abs = Math.abs(delta);

  if (abs === 0) {
    return '0.0'; // fixed to one decimal
  }

  if (abs >= 1) {
    // For values >= 1 → keep 1 decimal place
    return abs.toFixed(1);
  }

  // For very small numbers → use significant figures
  return abs.toPrecision(1);
}

function NRAssetRiskChanged({ oldRisk, newRisk, ...rest }) {
  const newRiskScore = Number(newRisk?.score || null);
  const oldRiskScore = Number(oldRisk?.score || null);
  const theme = useTheme();
  let value = Number(newRiskScore.toFixed(1));
  let delta = oldRisk.category === 'UNSPECIFIED' ? 0 : newRiskScore - oldRiskScore;
  let variationColor = delta > 0 ? theme.palette.error.main : delta < 0 ? theme.palette.success.main : theme.palette.text.secondary;
  const weightedColor = getWeightedColor(!isNumber(value) ? 0 : value, theme);
  const weightedColorAlt = getWeightedColorAlt(!isNumber(value) ? 0 : value, theme);

  return (
    <Box {...rest}>
      <Box sx={{ color: variationColor, display: 'flex', alignItems: 'center' }}>
        {delta !== 0 && (
          <ArrowDropDown style={{ width: 20, height: 20, marginRight: theme.spacing(0.5), transform: `rotate(0.${delta > 0 ? 5 : 0}turn)` }} />
        )}
        {formatDelta(delta)}
      </Box>
      <NRHighlightedText
        style={{ cursor: 'pointer', marginLeft: theme.spacing(2) }}
        color={weightedColor}
        colorAlt={weightedColorAlt}
        backgroundColor={weightedColor}
        textAlphaValue={!isNumber(value) ? 0.56 : 1}
        highlightAll={true}
        text={value}
        alphaValue={0.15}
        showBorder={true}
        minWidth={'48px'}
        justifyContent={'center'}
        fontSize={12}
        lineHeight={14}
      />
    </Box>
  );
}
export default NRAssetRiskChanged;
